export default "/images/vendor/flag-icons/flags/1x1/gm.svg?dfd25b88d3660d236c00fd9b79861dac";